<template>
  <v-form ref="form" v-model="validacion" lazy-validation
    ><!--ver para que el lazy validation xD -->
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex xs12 md4>
          <v-card max-width="330" height="415">
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Datos del Reclutado</v-toolbar-title
              >
            </v-toolbar>
            <br />
            <v-card-text>Rut: {{ this.rut + "-" + this.dv }}</v-card-text>
            <v-card-text>Nombre Reclutado: {{ this.nombre }} </v-card-text>
            <v-card-text>Apellido Paterno: {{ this.apellido }}</v-card-text>
            <v-card-text>Apellido Materno: {{ this.apellido1 }} </v-card-text>
          </v-card>
          <br />
        </v-flex>
        <v-flex md8>
          <v-card height="415">
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text">Evaluación</v-toolbar-title>
            </v-toolbar>
            <v-container>
              <v-layout>
                <v-flex xs12 md6>
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fecha_evaluacion"
                        label="Fecha evaluación"
                        :box="isDisabled"
                        :readonly="isDisabled"
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fecha_evaluacion"
                      @input="menu1 = false"
                      no-title
                      locale="es"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    :items="items"
                    v-model="select"
                    label="Select"
                    single-line
                    item-text="nombre"
                    return-object
                    persistent-hint
                    :box="isDisabled"
                    :readonly="isDisabled"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 md12>
                  <v-textarea
                    v-model="observacionEspecial"
                    label="Detalle de las acciones preventivas que se pueden aplicar al proceso de cada reclutado"
                    :box="isDisabled"
                    :readonly="isDisabled"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'modifica'"
        color="primary"
        dark
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "evaluacion-data",

  components: {
    Loading,
  },
  mixins: [misMixins],
  props: {
    tabSelected: "",
  },

  data() {
    return {
      select: { nombre: "Sin asignar" },
      items: [
        { nombre: "MUY BUENO" },
        { nombre: "BUENO" },
        { nombre: "REGULAR" },
        { nombre: "INSUFICIENTE" },
      ],
      text: "En construccion",
      loading: false,
      contratoId: "",
      usuarioLogged: "",
      fecha_evaluacion: "",
      menu1: false,
      tipeView: "",
      id: "",
      observacionEspecial: "",
      validacion: "",
      rut: "",
      dv: "",
      nombre: "",
      apellido: "",
      apellido1: "",
    };
  },
  mounted() {},
  computed: {
    isDisabled() {
      if (this.tipeView == "consulta") {
        return true;
      }
    },
  },
  created() {
    this.tipeView = this.$route.params.tipeView;
    this.id = this.$route.params.id;
    this.rut = this.$route.params.rut;
    this.dv = this.$route.params.dv;
    this.nombre = this.$route.params.nombre;
    this.apellido = this.$route.params.apellido;
    this.apellido1 = this.$route.params.apellido1;
    this.loadData();
  },

  methods: {
    async loadData() {
      this.id = this.$route.params.id;
      this.evaluacion = await this.loadEvaluacion();
      this.fecha_evaluacion = this.evaluacion.fechaEvaluacion;
      this.select = this.evaluacion.resultadoEval.descripcion;
      this.observacionEspecial = this.evaluacion.accionesPreventivas;
    },
    async loadEvaluacion() {
      let idContrato = this.$store.getters.contratoStored;
      let idEvaluacion = this.id;

      return await axios
        .get("/candidatos/evaluacion/get/" + idContrato + "/" + idEvaluacion)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    save() {
      let idEvaluacion = this.id;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
        fechaEvaluacion: this.formatoFecha(this.fecha_evaluacion),
        resultado: this.select.nombre,
        accionesPreventivas: this.observacionEspecial,
      };
      axios
        .put("/candidatos/evaluacion/edit/" + idEvaluacion, this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
        });
    },
    back() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
